import React, { useState } from 'react';

import './ContactLensType.scss';

const CONTACT_LENS_TYPE_LIST = [
  {
    key: 'daily',
    title: 'Daily',
  },
  {
    key: 'monthly',
    title: 'Monthly',
  },
];

export const ContactLensType = props => {
  const { isDailyOnly } = props;

  const [selectedType, setSelectedType] = useState(isDailyOnly ? 'daily' : 'monthly');

  return (
    <div className="contact-lens-type__container">
      <h3 className="contact-lens-type__title">Usage type</h3>

      <ul className="contact-lens-type__list">
        {CONTACT_LENS_TYPE_LIST.filter(({ key }) => (isDailyOnly ? key === 'daily' : true)).map(
          ({ key, title }) => (
            <li key={key} data-selected={selectedType === key} onClick={() => setSelectedType(key)}>
              <span>{title.toUpperCase()}</span>
            </li>
          )
        )}
      </ul>
    </div>
  );
};
